import { SclaApplication } from 'features/scla/types';
import { makeDeleteRequest } from 'lib/axios';

const clearSclaSignature = async (
  id: string,
  who: 'student' | 'parent',
): Promise<SclaApplication> => {
  const response = await makeDeleteRequest(`/scla/application/signature/${who}/${id}`);
  return response.data.payload;
};

export default clearSclaSignature;
